var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('HeadBar'),_c('Layout',{staticClass:"ivu-layout-has-sider"},[_c('NavigationBar',{attrs:{"active":"0"}}),_c('Layout',{staticClass:"content-wrap"},[_c('Content',{staticClass:"content"},[_c('div',{staticClass:"welcome"},[_c('img',{attrs:{"src":"/img/logo.png"}}),_c('h1',[_vm._v("欢迎登录运营控制台")])])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }